import styled from '../../styles/theme';
import { rem } from 'polished';
import { MultiSelectTemplate } from './MultiSelectTemplate';
import { isBrandOV } from '../../constants/main';
import { StylesOV } from './Styles.OV';

export const MultiSelectStyled = styled(MultiSelectTemplate)`
    position: relative;
    height: ${rem('44px')};
    display: flex;
    align-items: center;

    .label,
    .title {
        text-transform: uppercase;
        font-size: ${({ theme }) => theme.fontSizes.textBase};
        font-weight: ${({ theme }) => theme.fontWeights.textRegular};
    }

    .hasSomeSelected {
        color: ${({ theme }) => theme.colors.primary};

        svg {
            path {
                fill: ${({ theme }) => theme.colors.primary};
            }
        }
    }

    .is-open-extra-filter {
        svg {
            transform: rotate(180deg);
        }
    }

    button {
        width: 100%;
        background: unset;
        border: unset;
        padding: 0;
        display: flex;
        justify-content: space-between;

        svg {
            path {
                fill: ${({ theme }) => theme.colors.black3};
            }
            height: ${rem('12px')};
        }
    }

    .options {
        position: absolute;
        width: 100%;
        top: 2.5rem;
        padding: ${rem('5px')};
        left: 0;
        z-index: 100;
        background: ${({ theme }) => theme.colors.white};
        display: flex;
        flex-direction: column;
        box-shadow: 1px 2px 2px 2px rgba(0, 0, 0, 0.3);

        .container {
            display: block;
            height: ${rem('20px')};
            position: relative;
            padding-left: ${rem('35px')};
            margin: ${rem('10px')};
            cursor: pointer;
            user-select: none;

            &:hover {
                color: ${({ theme }) => theme.colors.primary};
            }
        }

        .container input {
            position: absolute;
            opacity: 0;
            cursor: pointer;
            height: 0;
            width: 0;
        }

        .label {
            line-height: ${rem('25px')};
        }

        .checkmark {
            position: absolute;
            top: 0;
            left: 0;
            height: ${rem('25px')};
            width: ${rem('25px')};
            background-color: ${({ theme }) => theme.colors.white};
            border: 1px solid ${({ theme }) => theme.colors.primary};
        }

        .container input:checked ~ .checkmark {
            background-color: ${({ theme }) => theme.colors.primary};
        }

        .container input:checked ~ .checkmark:after {
            display: block;
            opacity: 1;
        }

        .container .checkmark:after {
            opacity: 0;
            transform: translate(${rem('4px')}, ${rem('3px')});
            content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 18 12' width='15px' height='11px'%3E%3Cg fill='%23ffff'%3E%3Cpath d='M7.27702 11.9472L0.607422 5.27763L1.79542 4.08963L7.27702 9.57363L16.2074 0.64563L17.393 1.83363L7.27702 11.9472Z' /%3E%3Ccircle cx='420.9' cy='296.5' r='45.7' /%3E%3Cpath d='M520.5 78.1z' /%3E%3C/g%3E%3C/svg%3E%0A");
        }
    }
    ${isBrandOV && StylesOV}
`;
